<template>
    <div class="col">
        <q-card
            flat bordered
            class="col-6"
        >
            <q-card-section
                class="q-pa-sm row justify-between items-center bg-primary text-white text-bold"
            >
                Dispatch Information
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row items-center justify-between">
                    <table border="1" padding="0">
                        <tbody>
                            <tr>
                                <th>Pickup Date :</th>
                                <td>{{dinfo.pickupDate | usDateFormat}}</td>
                            </tr>
                            <tr>
                                <th>Delivery Date :</th>
                                <td>{{dinfo.deliveryDate | usDateFormat}}</td>
                            </tr>
                            <tr class="sep">
                                <th>...</th>
                                <td>...</td>
                            </tr>
                            <tr>
                                <th>Carrier Name :</th>
                                <td v-if="dinfo.driver.carrier">
                                    {{dinfo.driver.carrier.companyName}}
                                </td>
                            </tr>
                            <tr>
                            <th>Phone Number :</th>
                                <td v-if="dinfo.driver.carrier">
                                    {{getMaskedPhoneNumber(dinfo.driver.carrier.phoneNumber)}}
                                </td>
                            </tr>
                            <tr v-if="dinfo.driver.phoneNumber &&
                                dinfo.driver.phoneNumber !== dinfo.driver.carrier.phoneNumber"
                            >
                                <th>Driver Phone :</th>
                                <td>
                                    {{getMaskedPhoneNumber(dinfo.driver.phoneNumber)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <q-icon name="local_shipping" size="4.4em" color="brand5"/>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
export default {
  name: 'AppOrderDispatchInfo',
  props: ['dispatch'],

  data() {
    return {
        dinfo: this.dispatch
    };
  },
  methods: {
    getMaskedPhoneNumber(phoneNumber) {
        const number = phoneNumber.substring(0, 2) === '+1' ?
                        phoneNumber.substring(2) :
                        phoneNumber;

        const re = /(\d{3})(\d{3})(\d{4})/;
        return number.replace(re, (_, a, b, c) => `(${a}) - ${b} - ${c}`);
    }
  }
};
</script>
<style scoped lang="scss">
table {
   border-collapse: collapse;
   tr.sep{
    td,th{
        text-indent: -9999px;
        visibility: hidden;
    }
   }
   th,td{
    padding:5px 10px;
   }
   th{
    text-align: left;
   }
   td{
    text-align: right;
   }
}
</style>
